import { useMemo } from 'react';
import { useClearRefinements, useMenu } from 'react-instantsearch';
import { useIdentity } from '../../hooks';
import { trackEvent } from '../../utils/analytics';
import SingleSelectFilter from '../product-search/shared/SingleSelectFilter';

function CustomMenuSelectDivision({ label, divisions = {} }) {
  const { items, refine } = useMenu({ attribute: 'division_ids', limit: 100 });
  const { refine: clearRefine } = useClearRefinements({
    includedAttributes: ['division_ids'],
  });
  const identity = useIdentity();

  const options = useMemo(() => {
    return items
      .map((item) => {
        const divisionId = String(item.value);
        const divisionName = divisions[divisionId];
        if (!divisionName) {
          return null;
        }

        return {
          value: divisionId,
          label: `${divisionName} (${item.count})`,
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [items, divisions]);

  const selectedOption = options.find((option) => {
    return items.some((item) => item.isRefined && String(item.value) === option.value);
  });

  return (
    <SingleSelectFilter
      label={label}
      value={selectedOption || null}
      onChange={(event) => {
        const selectedDivisionId = event?.value ? String(event.value) : '';
        const currentRefinedValue = String(items.find((item) => item.isRefined)?.value || '');

        if ('' === selectedDivisionId) {
          clearRefine();
          return;
        }

        if (currentRefinedValue === selectedDivisionId) {
          return;
        }

        trackEvent('click_division_filter', {
          tenant_id: identity.tenant_id,
          login_email: identity.login_email,
          division: selectedDivisionId,
        });

        refine(selectedDivisionId);
      }}
      isClearable={items.some((item) => item.isRefined)}
      options={options}
    />
  );
}

export default CustomMenuSelectDivision;
